<template>
  <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="600px"
      :before-handleClose="handleClose"
      :handleClose-on-click-modal="false"
      class="look-dialog">
    <div class="look-one">
      <div class="look" id="look" v-html="data"></div>
    </div>
    <div class="operating">
        <el-button type="primary" size="medium" 
          @click="submitDate">
          保存
        </el-button>
        <el-button size="medium" @click="handleClose()">
          取消
        </el-button>
    </div>
  </el-dialog>
</template>
<script>
import API from "@/api";
export default {
  data() {
    return {
      dialogVisible: false,
      title: '预览',
      data: "",
      id: "",
    }
  },
  updated() {
    if (!this.dialogVisible) {
      return
    }
    var dom = document.getElementById("look")
    dom.style.width = "414px"
    //img数量
    var li = dom.getElementsByTagName("img").length
    //循环动态更新图片宽度
    for (let index = 0; index < li; index++) {
      dom.getElementsByTagName("img")[index].style.width = "414px"
    }
    //p数量
    var lp = dom.getElementsByTagName("p").length
    //循环动态更新段落宽度
    for (let index = 0; index < lp; index++) {
      dom.getElementsByTagName("p")[index].style.width = "414px"
    }
  },
  methods: {
    // 保存
    submitDate() {
      if (this.data == null || this.data==""){
          alert("保存内容为空")
          return
      }
      //去掉源站地址
      var graphic = this.data;
      const params = {
        "graphic": graphic
      }
      if (this.id != null && this.id != "") {
        //编辑
        params.id = this.id
        API.editAvComment(params)
          .then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "保存成功！",
                type: "success",
              });
              this.$emit("handlerLoadList");
            } else {
              this.$message.error("保存失败！");
            }
            this.handleClose();
          })
          .catch(() => {
            this.handleClose();
          });
      } else {
        //新增
        API.addAvComment(params)
          .then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "保存成功！",
                type: "success",
              });
              this.$emit("handlerLoadList");
            } else {
              this.$message.error("保存失败！");
            }
            this.handleClose();
          })
          .catch(() => {
            this.handleClose();
          });
      }
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(data, id) {
      this.dialogVisible = true
      if (data != null){
        this.data = data
      }
      if (id != null && id != "") {
        this.id = id
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.look-dialog{
  z-index: 999999 !important;
}
.look{
  position: relative;
  left: 50%;
  transform: translate(-50%);
}
.look-one{
  border: 2px solid; color: #121327;
  border-radius: 12px;
  // background-color: #121327;
  width: 500px;
  margin-left: 30px;
}
.operating{
  text-align:center;
  margin-top: 15px;
}
</style>